import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const ProblemReport = ({
	color,
	size,
	className,
}: {
	color?: string;
	size?: number;
	className?: string;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M30 10H12C6.47716 10 2.00001 14.4772 2.00001 20C2.00001 20.113 2 20.1167 2 20.1167C2 20.1205 2 20.1242 2.00001 21C2.00002 22.3164 0 22.5 0 21C0 19.9822 2.3093e-06 20.0403 3.79413e-06 20.0776C4.49767e-06 20.0952 5.01611e-06 20.1083 5.01611e-06 20C5.01611e-06 13.3726 5.37259 8 12 8H30C36.6274 8 42 13.3726 42 20C42 26.6274 36.6274 32 30 32H10C8.5 32 8.5 30 10 30H30C35.5229 30 40 25.5228 40 20C40 14.4772 35.5229 10 30 10Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				d='M8 16C7.44772 16 7 16.4477 7 17C7 17.5523 7.44772 18 8 18H33C33.5523 18 34 17.5523 34 17C34 16.4477 33.5523 16 33 16H8Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				d='M1.01694 25.7888C0.844838 24.3035 2.00599 23 3.50131 23C4.99662 23 6.15778 24.3035 5.98567 25.7888L5.37968 31.019C5.26917 31.9728 4.46145 32.6923 3.50131 32.6923C2.54117 32.6923 1.73344 31.9728 1.62293 31.019L1.01694 25.7888Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				d='M5.18581 35.3846C5.18581 36.2768 4.43163 37 3.50131 37C2.57099 37 1.81681 36.2768 1.81681 35.3846C1.81681 34.4925 2.57099 33.7692 3.50131 33.7692C4.43163 33.7692 5.18581 34.4925 5.18581 35.3846Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				d='M10 24C10 23.4477 10.4477 23 11 23H33C33.5523 23 34 23.4477 34 24C34 24.5523 33.5523 25 33 25H11C10.4477 25 10 24.5523 10 24Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
